import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import BASE_URL from '../../config';
import { fetchWithAuth } from '../../utils/authUtils';
import { readErrorResponse } from '../../utils/readErrorResponse';

export const fetchUserProducts = createAsyncThunk(
    "userProducts/fetchUserProducts",
    async ({ page, pageSize, userId = null }, { rejectWithValue }) => {
      try {
        let url = `${BASE_URL}/products/v1/user-products/?page=${page}&page_size=${pageSize}`;
        
        // Если передан userId, добавляем его в запрос (для просмотра чужого профиля)
        if (userId) {
          url += `&user_id=${userId}`;
        }
        
        const response = await fetchWithAuth(url, {
          method: 'GET',
        });
  
        if (!response.ok) {
          const errorDetails = await readErrorResponse(response);
          console.error('Server responded with error:', errorDetails);
          return rejectWithValue(errorDetails);
        }
  
        return await response.json();
      } catch (error) {
        console.error('Error:', error);
        return rejectWithValue(error.message);
      }
    }
);

export const fetchPurchasedProducts = createAsyncThunk(
    "userProducts/fetchPurchasedProducts",
    async ({ page, pageSize }, { rejectWithValue }) => {
      try {
        const url = `${BASE_URL}/products/v1/purchased-products/?page=${page}&page_size=${pageSize}`;
        
        const response = await fetchWithAuth(url, {
          method: 'GET',
        });
  
        if (!response.ok) {
          const errorDetails = await readErrorResponse(response);
          console.error('Server responded with error:', errorDetails);
          return rejectWithValue(errorDetails);
        }
  
        return await response.json();
      } catch (error) {
        console.error('Error:', error);
        return rejectWithValue(error.message);
      }
    }
);

const initialState = {
    userProducts: [],
    purchasedProducts: [],
    status: 'idle',
    purchasedStatus: 'idle',
    error: null,
    purchasedError: null,
};

const profileProductSlice = createSlice({
    name: "profileProduct",
    initialState,
    reducers: {
        clearUserProducts: (state) => {
            state.userProducts = [];
            state.status = 'idle';
            state.error = null;
        }
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchUserProducts.pending, (state) => {
          state.status = 'loading';
        })
        .addCase(fetchUserProducts.fulfilled, (state, action) => {
          state.status = 'succeeded';
          state.userProducts = action.payload;
        })
        .addCase(fetchUserProducts.rejected, (state, action) => {
          state.status = 'failed';
          state.error = action.payload;
        })
        .addCase(fetchPurchasedProducts.pending, (state) => {
          state.purchasedStatus = 'loading';
        })
        .addCase(fetchPurchasedProducts.fulfilled, (state, action) => {
          state.purchasedStatus = 'succeeded';
          state.purchasedProducts = action.payload;
        })
        .addCase(fetchPurchasedProducts.rejected, (state, action) => {
          state.purchasedStatus = 'failed';
          state.purchasedError = action.payload;
        });
    },
});

export const { clearUserProducts } = profileProductSlice.actions;
export default profileProductSlice.reducer;
